export default "__VITE_ASSET__DMveJ2BJ__"